import _defineProperty from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import Input from '../input';
import Button from '../button';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { SearchOutline } from 'antd-mobile-icons';
import { usePropsValue } from '../../utils/use-props-value';
import { useConfig } from '../config-provider';
var classPrefix = "adm-search-bar";
var defaultProps = {
  clearable: true,
  onlyShowClearWhenFocus: false,
  showCancelButton: false,
  defaultValue: '',
  clearOnCancel: true,
  icon: React.createElement(SearchOutline, null)
};
export var SearchBar = forwardRef(function (p, ref) {
  var _useConfig = useConfig(),
      locale = _useConfig.locale;

  var props = mergeProps(defaultProps, {
    cancelText: locale.common.cancel
  }, p);

  var _usePropsValue = usePropsValue(props),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      value = _usePropsValue2[0],
      setValue = _usePropsValue2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var inputRef = useRef(null);
  var composingRef = useRef(false);
  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        var _a;

        return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.clear();
      },
      focus: function focus() {
        var _a;

        return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;

        return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      },

      get nativeElement() {
        var _a, _b;

        return (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement) !== null && _b !== void 0 ? _b : null;
      }

    };
  });

  var renderCancelButton = function renderCancelButton() {
    var isShowCancel;

    if (typeof props.showCancelButton === 'function') {
      isShowCancel = props.showCancelButton(hasFocus, value);
    } else {
      isShowCancel = props.showCancelButton && hasFocus;
    }

    return isShowCancel && React.createElement("div", {
      className: "".concat(classPrefix, "-suffix")
    }, React.createElement(Button, {
      fill: 'none',
      className: "".concat(classPrefix, "-cancel-button"),
      onClick: function onClick() {
        var _a, _b, _c;

        if (props.clearOnCancel) {
          (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        }

        (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.blur();
        (_c = props.onCancel) === null || _c === void 0 ? void 0 : _c.call(props);
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      }
    }, props.cancelText));
  };

  return withNativeProps(props, React.createElement("div", {
    className: classNames(classPrefix, _defineProperty({}, "".concat(classPrefix, "-active"), hasFocus))
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-input-box")
  }, props.icon && React.createElement("div", {
    className: "".concat(classPrefix, "-input-box-icon")
  }, props.icon), React.createElement(Input, {
    ref: inputRef,
    className: classNames("".concat(classPrefix, "-input"), _defineProperty({}, "".concat(classPrefix, "-input-without-icon"), !props.icon)),
    value: value,
    onChange: setValue,
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    clearable: props.clearable,
    onlyShowClearWhenFocus: props.onlyShowClearWhenFocus,
    onFocus: function onFocus(e) {
      var _a;

      setHasFocus(true);
      (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
    },
    onBlur: function onBlur(e) {
      var _a;

      setHasFocus(false);
      (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
    },
    onClear: props.onClear,
    type: 'search',
    enterKeyHint: 'search',
    onEnterPress: function onEnterPress() {
      var _a, _b;

      if (!composingRef.current) {
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        (_b = props.onSearch) === null || _b === void 0 ? void 0 : _b.call(props, value);
      }
    },
    "aria-label": locale.SearchBar.name,
    onCompositionStart: function onCompositionStart() {
      composingRef.current = true;
    },
    onCompositionEnd: function onCompositionEnd() {
      composingRef.current = false;
    }
  })), renderCancelButton()));
});